angular.module('modals')
    .controller('PatientModalController', ['$scope', '$uibModalInstance', 'Logger', 'Auth', 'ModalHandler', 'Patient', 'fullname', '$uibModal', 'Alert',
        function ($scope, $uibModalInstance, Logger, Auth, ModalHandler, Patient, fullname, $uibModal, Alert) {

            $scope.title = 'Create a New Patient Record';
            $scope.alerts = [];
            $scope.datepickerStatus = { opened: false };

            if (fullname) {
                var spacePosition = fullname.lastIndexOf(' '); //lastIndexOf is needed for names with several words, like Jean Francois Moullin, where Jean Francois is a name and Moullin is a surname
                var first_name = '';
                var last_name = '';
                if (fullname != '' && spacePosition == -1) {
                    first_name = fullname;
                } else {
                    first_name = fullname.substr(0, spacePosition);
                    last_name = fullname.substr(spacePosition + 1);
                }
                $scope.patient = { 'first_name': first_name, 'last_name': last_name };
            }

            $scope.ok = function (patient) {
                patient.practice_id = Auth.get() ? Auth.get().practice_id : '';
                patient.birthday = moment(patient.birthday).format('YYYY-MM-DD');//fix for #114475519
                function createPatient() {
                    Patient.save({ patient: patient },
                        function (success) {
                            ModalHandler.close($uibModalInstance, success);
                        },
                        function (failure) {
                            $scope.alerts = [];
                            Alert.error($scope.alerts, 'Error occurred during patient create.', true)
                        });
                };

                if (patient.practice_id) {
                    Patient.searchPatientDuplicate(patient,
                        function (success) {
                            if (success.patient) {
                                var dedupingModalInstance = $uibModal.open({
                                    templateUrl: 'partials/patient_deduping_form.html',
                                    controller: 'DedupingPatientModalController',
                                    resolve: {
                                        isCreatingPatient: function () {
                                            return true;
                                        }
                                    }
                                });

                                dedupingModalInstance.result.then(function (useExistingPatient) {
                                    if (useExistingPatient) {
                                        ModalHandler.close($uibModalInstance, success.patient);
                                    } else {
                                        createPatient();
                                    }
                                }).catch(function () {
                                    Logger.log('Modal dismissed');
                                });
                            } else {
                                createPatient();
                            }
                        });
                } else {
                    ModalHandler.close($uibModalInstance, patient);
                }

            };
            $scope.openDatePicker = function ($event) {
                $scope.datepickerStatus.opened = true;
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);

            };
        }])

    .controller('DedupingPatientModalController', ['$scope', '$uibModalInstance', 'isCreatingPatient',
        function ($scope, $uibModalInstance, isCreatingPatient) {
            $scope.useExistingPatient = true;
            $scope.isCreatingPatient = isCreatingPatient;

            $scope.ok = function () {
                $uibModalInstance.close($scope.useExistingPatient);
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }])

    .controller('EditPatientModalController', ['$scope', '$state', '$uibModalInstance', 'Logger', 'Alert', 'ModalHandler', 'Patient', 'patientForEdit', '$uibModal',
        function ($scope, $state, $uibModalInstance, Logger, Alert, ModalHandler, Patient, patientForEdit, $uibModal) {
            $scope.title = 'Edit Patient Record';
            $scope.datepickerStatus = { opened: false };
            $scope.alerts = [];
            $scope.patient = { first_name: patientForEdit.first_name, last_name: patientForEdit.last_name, birthday: moment(patientForEdit.birthday).toDate(), email: patientForEdit.email, phone: patientForEdit.phone };//we need a copy of the object to be able to cancel changes (otherwise two-way binding changes the patient's data on parent page right away)
            $scope.ok = function (patient) {
                patient.birthday = moment(patient.birthday).format('YYYY-MM-DD');//fix for #114475519
                function updatePatient() {
                    Patient.update({ id: patientForEdit.id }, { patient: patient },
                        function (success) {
                            ModalHandler.close($uibModalInstance, success);
                        },
                        function (failure) {
                            $scope.alerts = [];
                            Alert.error($scope.alerts, 'Error occurred during patient update.', true);
                        });
                };

                patient.id = patientForEdit.id;
                patient.practice_id = patientForEdit.practice_id;

                if ($state.is('createReferral')) {
                    Patient.searchPatientDuplicate(patient,
                        function (success) {
                            if (success.patient) {
                                var dedupingModalInstance = $uibModal.open({
                                    templateUrl: 'partials/patient_deduping_form.html',
                                    controller: 'DedupingPatientModalController',
                                    resolve: {
                                        isCreatingPatient: function () {
                                            return false;
                                        }
                                    }
                                });

                                dedupingModalInstance.result.then(function (useExistingPatient) {
                                    if (useExistingPatient) {
                                        ModalHandler.close($uibModalInstance, success.patient);
                                    } else {
                                        updatePatient();
                                    }
                                }).catch(function () {
                                    Logger.log('Modal dismissed');
                                });
                            } else {
                                updatePatient();
                            }

                        });
                } else {
                    updatePatient();
                }

            };

            $scope.openDatePicker = function ($event) {
                $scope.datepickerStatus.opened = true;
            };

            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('ChangeDestProviderModalController', ['$scope', '$uibModalInstance', 'Alert', 'ModalHandler', 'Referral', 'referral', 'USER_ROLES',
        function ($scope, $uibModalInstance, Alert, ModalHandler, Referral, referral, USER_ROLES) {
            $scope.providerId = referral.dest_provider_id;
            $scope.referral = angular.copy(referral);

            $scope.referral.dest_practice.users.unshift({ id: -1, first_name: 'First', last_name: 'Available', firstAvailable: true, addresses: $scope.referral.dest_practice.addresses });
            $scope.doctorRoleMask = USER_ROLES.doctor.mask;

            $scope.filterByAddress = function (addressId) {
                return function (item) {
                    for (var i = 0; i < item.addresses.length; i++) {
                        if (item.addresses[i].id === addressId) {
                            return true;
                        }
                    }
                    return false;
                };
            };
            $scope.ok = function (providerId) {
                $scope.referral.dest_practice.users.shift();
                referral = $scope.referral;
                Referral.update({ id: referral.id }, { referral: { dest_provider_id: providerId, address_id: $scope.referral.address_id } },
                    function (success) {
                        ModalHandler.close($uibModalInstance, providerId);
                    },
                    function (failure) {
                        Alert.error($scope.alerts, 'Error occurred during referral update.');
                    });
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('NoteModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'Referral', 'referral', 'allowGenerate',
        function ($scope, $uibModalInstance, ModalHandler, Referral, referral, allowGenerate) {
            $scope.drafts = [];
            $scope.allowGenerate = allowGenerate;

            $scope.ok = function (note) {
                //nothing to do, we cant save note right here because at this stage referral doesn't exist. We can only add new note to the list on the parent page (create referral) and save simultaneously with referral.
                if (note == undefined || note.match(/^\s*$/)) {
                    ModalHandler.dismiss($uibModalInstance);
                } else {
                    ModalHandler.close($uibModalInstance, note);
                }

            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };

            $scope.generateDrafts = function () {
                Referral.getNoteDrafts({id: referral.id}).$promise
                    .then(function (drafts) {
                        $scope.drafts = drafts;

                        if ($scope.drafts.length > 0) {
                            $scope.insertDraft($scope.drafts[0]);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            };

            $scope.insertDraft = function(draft) {
                $scope.note = draft.note;
                var textarea = document.getElementById('note');
                textarea.focus();
            };
        }])

    .controller('EditNoteModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'noteData',
        function ($scope, $uibModalInstance, ModalHandler, noteData) {
            $scope.note = angular.copy(noteData);

            $scope.ok = function (note) {
                if (note == undefined || note.message.match(/^\s*$/)) {
                    ModalHandler.dismiss($uibModalInstance);
                } else {
                    ModalHandler.close($uibModalInstance, $scope.note);
                }
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };

        }])
    .controller('NoteVersionsModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'versions',
        function ($scope, $uibModalInstance, ModalHandler, versions) {
            $scope.versions = versions;
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            };

        }])

    .controller('ProviderModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'ProviderInvitation', 'Alert', 'dependsOnReferral', 'inviterId',
        function ($scope, $uibModalInstance, ModalHandler, ProviderInvitation, Alert, dependsOnReferral, inviterId) {
            // dependsOnReferral - is true when this dialog is opened from create_referral page

            $scope.alerts = [];
            $scope.model = {};
            $scope.isProviderInvite = true;
            $scope.suggest_practice = null;

            $scope.$watch( //we need only one-way updates from typeahead, otherwise typeahead works incorrectly
                function () {
                    return $scope.model.existingProvider;
                }, function (newVal, oldVal, scope) {
                    if (newVal) {
                        $scope.model.provider = { id: newVal.id, first_name: newVal.first_name, email: newVal.email, last_name: newVal.last_name };
                    }
                });
            $scope.ok = function (provider) {
                provider.inviter_id = inviterId;
                $scope.suggest_practice = null; // reset

                // Todo: is create() taken? Because it doesn't save a provider, it creates an invitation.
                // Maybe refactor to use the same API endpoint and NG service regardless of type of invitation?
                ProviderInvitation.saveProvider(
                    {
                        provider_invitation: provider,
                        send_email: !dependsOnReferral,  // when false - invitation is still created, but email message is not sent here.
                        front_desk: !$scope.isProviderInvite
                    },
                    function (provider) {
                        ModalHandler.close($uibModalInstance, { provider: provider });
                    },
                    function (failure) {
                        $scope.alerts = [];
                        var data = failure.data;
                        var practice = data.suggest_practice;
                        if (data.errors) {
                            data = data.errors;
                        }
                        var message = data.message[0];

                        if (message == 'user.exists' && practice) {
                            if (dependsOnReferral) {
                                $scope.suggest_practice = practice;
                            } else {
                                // When opened from Admin->Colleagues, no need to select existing invitation for anytihng, as of now.
                                Alert.error($scope.alerts, 'colleague.exists', true);
                            }
                        } else {
                            Alert.error($scope.alerts, message, true);
                        }
                    });
            };
            $scope.reset_suggest_practice = function () {
                $scope.suggest_practice = null;
            };
            $scope.selectExistingPractice = function (practice) {
                ModalHandler.close($uibModalInstance, { practice: practice });
            };
            $scope.closeAlert = function (index) {
                Alert.close($scope.alerts, index);
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('PracticeDeleteModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'Practice', 'User', 'Referral', 'selectedPractice', 'Notification',
        function ($scope, $uibModalInstance, ModalHandler, Practice, User, Referral, selectedPractice, Notification) {
            $scope.practice = angular.copy(selectedPractice);
            $scope.delete_type = 'delete_practice';
            $scope.dest_practice = {};
            $scope.dest_user = '';

            Referral.countByPractice({ id: $scope.practice.id },
                function (success) {
                    $scope.referrals_count = success.count;
                });

            $scope.findPractice = function (searchValue) {
                $scope.dest_practice = {};
                return Practice.publicSearchPractice({ search: searchValue }).$promise;
            };

            $scope.onPracticeSelected = function (destPractice) {
                $scope.dest_practice = destPractice;
                User.getAllUsers({ practice_id: destPractice.id },
                    function (users) {
                        $scope.dest_practice.users = [];
                        $scope.dest_practice.users.push({ first_name: 'First', last_name: 'Available', id: -1 });
                        $scope.dest_practice.users = $scope.dest_practice.users.concat(users);
                    });
            };

            $scope.deletePractice = function () {
                var error = {};
                if ($scope.delete_type == 'delete_practice') {
                    Practice.delete({ practiceId: $scope.practice.id },
                        function (success) {
                            Notification.success('Practice delete success');
                        }, function (failure) {
                            error = failure;
                        });
                } else if ($scope.delete_type == 'move_referrals') {
                    Practice.deleteAndMoveReferral({ id: $scope.practice.id, dest_practice_id: $scope.dest_practice.id, dest_user_id: $scope.dest_user.id },
                        function (success) {
                            Notification.success('Practice delete success');
                        }, function (failure) {
                            error = failure;
                        });
                }

                ModalHandler.close($uibModalInstance, error);
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    // Controller for New User dialog, view is: user_form.html
    .controller('UserModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'ProviderInvitation', 'Registration', 'Auth', 'Alert', 'Logger', 'USER_ROLES', 'Role', 'practice', 'practiceTypes',
        function ($scope, $uibModalInstance, ModalHandler, ProviderInvitation, Registration, Auth, Alert, Logger, USER_ROLES, Role, practice, practiceTypes) {
            $scope.practice = angular.copy(practice);
            $scope.practiceTypes = practiceTypes.filter(function (type) {
                return type.code != 'multi_specialty';
            });
            $scope.result = {};
            $scope.alerts = [];
            $scope.isInvite = true;
            $scope.isAux = false;
            $scope.user = {};
            $scope.user.roles_mask = 0;
            $scope.user.specialty_type_id = $scope.practice.practice_type.code != 'multi_specialty' ? $scope.practice.practice_type_id : '';
            $scope.defaultRoles = [USER_ROLES.aux];
            $scope.showRoles = [USER_ROLES.aux, USER_ROLES.doctor, USER_ROLES.admin];

            $scope.toggleRadio = function () {
                if (!$scope.isInvite) {
                    $scope.defaultRoles = [USER_ROLES.doctor];
                    $scope.showRoles = [USER_ROLES.doctor];
                } else {
                    $scope.defaultRoles = [USER_ROLES.aux];
                    $scope.showRoles = [USER_ROLES.doctor, USER_ROLES.aux, USER_ROLES.admin];
                }
            };

            $scope.onRoleChange = function (resultMask) {
                $scope.isAux = Role.hasRoles([USER_ROLES.aux], Role.getFromMask(resultMask));
            };

            $scope.ok = function (user) {
                user.practice_id = ($scope.params && $scope.params.practiceId) || Auth.getOrRedirect().practice_id;
                user.inviter_id = Auth.getOrRedirect().id;

                if ($scope.isAux) {
                    user.specialty_type_id = '';
                }

                if ($scope.isInvite) {
                    ProviderInvitation.saveUser({ provider_invitation: user },
                        function (invitation) {
                            ModalHandler.close($uibModalInstance, invitation);
                        }, function (failure) {
                            $scope.alerts = []; //reset alerts list because we need only one alert at a time
                            Alert.error($scope.alerts, failure.data.errors.message[0], true);
                            Logger.log($scope.alerts);
                        });
                } else {
                    Registration.create_no_login_user({ user: user },
                        function (user) {
                            ModalHandler.close($uibModalInstance, user);
                        }, function (failure) {
                            $scope.alerts = []; //reset alerts list because we need only one alert at a time
                            Alert.error($scope.alerts, failure.data.errors.message[0], true);
                            Logger.log($scope.alerts);
                        });
                }
            };

            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('UpgradeModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'Auth', 'Alert', 'Practice', 'Logger', 'ServerSettings', 'practice_id', 'stripe_subscription_id', 'interval', 'Spinner', 'stripe',
        function ($scope, $uibModalInstance, ModalHandler, Auth, Alert, Practice, Logger, ServerSettings, practice_id, stripe_subscription_id, interval, Spinner, stripe) {
            $scope.result = {};
            $scope.alerts = [];
            var currentYear = moment().year();
            $scope.years = [currentYear, currentYear + 1, currentYear + 2, currentYear + 3, currentYear + 4, currentYear + 5];

            $scope.stripe_subscription_id = stripe_subscription_id;
            Logger.log($scope.stripe_subscription_id);
            var handleError = function (failure) {
                Alert.error($scope.alerts, 'Error: can\'t access to payment system. Please try again later.', true);
                $scope.disableForm = true;
            };
            ServerSettings.getStripeApiPublicKey(function (success) {
                if (success.key) {
                    //key could be null if it was not set in server's environment variables
                    stripe.setPublishableKey(success.key);
                    // $window.Stripe.setPublishableKey(success.key);
                } else {
                    handleError();
                }
            }, handleError);

            $scope.ok = function (payment_info) {
                Spinner.show();
                return stripe.card.createToken({
                    number: payment_info.card_number,
                    cvc: payment_info.card_cvc,
                    exp_month: payment_info.card_exp_month,
                    exp_year: payment_info.card_exp_year
                })
                    .then(function (token) {
                        console.log('token created for card ending in ', token.card.last4);
                        Logger.log(payment_info);
                        return Practice.subscribe({ practiceId: practice_id }, {
                            practice: {
                                name_on_card: payment_info.name_on_card,
                                stripe_token: token.id,
                                subscription_interval: interval
                            }
                        },
                            function (success) {
                                Logger.log(success);
                                Alert.success($scope.alerts, 'Thank you for upgrading to a Premium Account. Your automatic renewal date  is ' + moment(success.subscription_active_until).format('MM-DD-YY'), true);
                                ModalHandler.close($uibModalInstance, success);
                            },
                            function (failure) {
                                $scope.alerts = [];
                                Alert.error($scope.alerts, 'An error occurred during account update: ' + failure.data.error, true)
                            });

                    })
                    .then(function (payment) {
                        Spinner.hide();
                        console.log('successfully submitted payment for $', payment.amount);
                    })
                    .catch(function (err) {
                        if (err.type && /^Stripe/.test(err.type)) {
                            $scope.alerts = [];
                            Alert.error($scope.alerts, 'An error occurred during account update: ' + err.message, true);
                            Spinner.hide();
                        }
                        else {
                            $scope.alerts = [];
                            Alert.error($scope.alerts, 'An error occurred during account update: ' + err.message, true)
                        }
                    });


            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('DowngradeModalController', ['$scope', '$uibModalInstance', 'ModalHandler',
        function ($scope, $uibModalInstance, ModalHandler) {
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('EditUserModalController', ['$scope', 'nameEditable', '$uibModalInstance', 'ModalHandler', 'User', 'Auth', 'Logger', 'editUser', 'practiceType', 'practiceAddresses', 'USER_ROLES', 'Role', 'Procedure', '$uibModal',
        function ($scope, nameEditable, $uibModalInstance, ModalHandler, User, Auth, Logger, editUser, practiceType, practiceAddresses, USER_ROLES, Role, Procedure, $uibModal) {
            $scope.result = {};
            $scope.alerts = [];
            $scope.nameEditable = nameEditable;
            $scope.practiceTypes = [];
            $scope.showRoles = [USER_ROLES.super, USER_ROLES.aux, USER_ROLES.doctor, USER_ROLES.admin];
            Procedure.practiceTypes({ 'include_procedures': false },
                function (success) {
                    success.map(function (item) {
                        if (item.code !== 'multi_specialty') {
                            $scope.practiceTypes.push(item);
                        }
                    });
                });
            $scope.user = editUser;
            $scope.hasLogin = !!editUser.email;
            $scope.practiceAddresses = practiceAddresses;
            $scope.user.is_admin = Role.hasRoles([USER_ROLES.admin], Role.getFromMask($scope.user.roles_mask));
            var initialEmail = editUser.email;

            $scope.auth = Auth.get();

            $scope.saveIsAdmin = function (user) {
                User.updateIsAdmin({ id: user.id }, user.is_admin ? 'true' : 'false').$promise
                    .then(function (success) {
                        Logger.log('Saved is_admin: ' + success.email);
                    })
                    .catch(function (failure) {
                        Logger.log('ERROR: ' + JSON.stringify(failure));
                    });
            };

            $scope.saveSpecialty = function(user) {
                User.updateSpecialty({ id: user.id }, { specialty_type_id: user.specialty_type_id }).$promise
                    .then(function (success) {
                        Logger.log('Saved specialty: ' + success.email);
                    })
                    .catch(function (failure) {
                        Logger.log('ERROR: ' + JSON.stringify(failure));
                    });
            };

            $scope.saveNotificationPreference = function (user) {
                User.updateNotificationPreference({ id: user.id }, { notification_preference: user.notification_preference }).$promise
                    .then(function (success) {
                        Logger.log('Saved notification preference: ' + success.email);
                    })
                    .catch(function (failure) {
                        Logger.log('ERROR: ' + JSON.stringify(failure));
                    });
            };

            $scope.roleName = function (roles_mask) {
                var str = '';
                Role.getFromMask(roles_mask).reverse().forEach(function (elem) {
                    str += str == '' ? elem.name : ', ' + elem.name;
                });
                return str;
            };

            $scope.is_multispecialty = function () {
                return Role.hasRoles([USER_ROLES.doctor], Role.getFromMask($scope.user.roles_mask)) && practiceType.code === 'multi_specialty';
            };

            $scope.changeNameModal = function(user) {
                if (!$scope.nameEditable) {
                    console.log('name is not editable');
                    return;
                }
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/user/change_name_modal.html',
                    controller: 'ChangeNameModalController',
                    resolve: {
                        user: function () {
                            return user;
                        }
                    }
                });
                ModalHandler.set(modalInstance);
                modalInstance.result.then(function (updatedUser) {
                    // Update the user object in the parent scope if needed
                    $scope.user.first_name = updatedUser.first_name;
                    $scope.user.last_name = updatedUser.last_name;
                    Logger.log('Name updated: ' + updatedUser.first_name + ' ' + updatedUser.last_name);
                }).catch(function() {
                    Logger.log('Change Name modal dismissed');
                });
            };

            $scope.changeEmailModal = function(user) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/user/change_email_modal.html',
                    controller: 'ChangeEmailModalController',
                    resolve: {
                        user: function () {
                            return user;
                        }
                    }
                });
                ModalHandler.set(modalInstance);
                modalInstance.result.then(function (email) {
                    Logger.log('Change initiated: new email = ' + email);
                }).catch(function() {
                    Logger.log('Modal dismissed');
                });
            };

            $scope.changePasswordModal = function(user) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/user/reset_password_modal.html',
                    controller: 'ResetPasswordModalController',
                    resolve: {
                        user: function () {
                            return user;
                        }
                    }
                });
                ModalHandler.set(modalInstance);
                modalInstance.result.then(function (email) {
                    Logger.log('Password reset requested: email = ' + email);
                }).catch(function() {
                    Logger.log('Modal dismissed');
                });
            };

            $scope.createLoginModal = function (user) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/user/create_login_modal.html',
                    controller: 'CreateLoginModalController',
                    resolve: {
                        user: function () {
                            return user;
                        }
                    }
                });
                ModalHandler.set(modalInstance);
                modalInstance.result.then(function (email) {
                    Logger.log('Create login requested: email = ' + email);
                    $uibModalInstance.dismiss('done');
                }).catch(function() {
                    Logger.log('Modal dismissed');
                });
            };

            $scope.done = function () {
                $uibModalInstance.dismiss('done');
            };
        }])

    .controller('ChangeNameModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'User', 'Alert', 'Logger', 'user',
        function ($scope, $uibModalInstance, ModalHandler, User, Alert, Logger, user) {
            $scope.user = angular.copy(user); // Use a copy to allow discarding changes
            $scope.alerts = [];

            $scope.ok = function (updatedUser) {
                User.updateName({ id: user.id }, { user: { first_name: updatedUser.first_name, last_name: updatedUser.last_name } }).$promise
                    .then(function (success) {
                        Alert.success($scope.alerts, 'User name updated successfully.', true);
                        // Pass the updated user back
                        ModalHandler.close($uibModalInstance, success); 
                    })
                    .catch(function (failure) {
                        $scope.alerts = [];
                        var message = (failure.data && failure.data.error) || 'An error occurred while updating the user name.';
                        Alert.error($scope.alerts, message, true);
                        Logger.log('ERROR updating name: ' + JSON.stringify(failure));
                    });
            };

            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('DatePickerModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'currentDate',
        function ($scope, $uibModalInstance, ModalHandler, currentDate) {
            $scope.date = currentDate;

            $scope.dateSelected = function () {
                ModalHandler.close($uibModalInstance, $scope.date);
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('RegistrationResultController', ['$scope', '$uibModalInstance', 'ModalHandler',
        function ($scope, $uibModalInstance, ModalHandler) {
            $scope.resultMessage = 'Thank you for registering your account on Dental Care Links. Your account is ready to start sending HIPAA Compliant referrals!';
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            }
        }])

    .controller('PendingReviewRegistrationResultController', ['$scope', '$uibModalInstance', 'ModalHandler', '$sce',
        function ($scope, $uibModalInstance, ModalHandler, $sce) {
            $scope.resultMessage = $sce.trustAsHtml('Thank you for registering your account on Dental Care Links.<br>' +
                'In order to ensure the highest level of security and quality of service, new accounts must be reviewed prior to being activated.<br>' +
                'This usually takes less than 24 hours.<br>' +
                'We will notify you as soon as your account is active. Thank you for your patience!');
    
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            }
        }])

    .controller('InviteUserResultController', ['$scope', '$uibModalInstance', 'ModalHandler', 'noLogin', 'toEmail',
        function ($scope, $uibModalInstance, ModalHandler, noLogin, toEmail) {
            if (noLogin) {
                $scope.modalHeader = 'User created successfully';
                $scope.resultMessage = "A new user has been created and is now listed as a provider in your practice. This user was created without login credentials. If you would like this user to be able to login to your account please edit their settings to add an email address.";
            } else {
                $scope.modalHeader = 'User invitation successful';
                $scope.resultMessage = 'Your invitation has been sent to ' + toEmail + '. The email message contains a special link to complete their registration, once this is done their account will be activated.';
            }

            $scope.ok = function() {
                ModalHandler.close($uibModalInstance);
            }
        }])

    .controller('InvitePracticeResultController', ['$scope', '$uibModalInstance', 'ModalHandler', 'toEmail',
        function ($scope, $uibModalInstance, ModalHandler, toEmail) {
            $scope.resultMessage = 'Your invitation has been sent to ' + toEmail + '. The email message contains a special link to complete their practice registration.';
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            }
        }])

    .controller('EmailChangeResultController', ['$scope', '$uibModalInstance', 'ModalHandler',
        function ($scope, $uibModalInstance, ModalHandler) {
            $scope.resultMessage = 'Your email was changed. Please login with your new credentials';
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            }
        }])

    .controller('ReferralSuccessModalController', ['$scope', '$uibModalInstance', 'ModalHandler',
        function ($scope, $uibModalInstance, ModalHandler) {
            $scope.cancel = function () {
                ModalHandler.close($uibModalInstance);
            };
            $scope.goDownload = function () {
                ModalHandler.close($uibModalInstance);
            }
        }])

    .controller('InvitationValidationController', ['$scope', '$uibModalInstance', 'Alert', 'ModalHandler', 'ProviderInvitation', 'invitation',
        function ($scope, $uibModalInstance, Alert, ModalHandler, ProviderInvitation, invitation) {
            $scope.alerts = [];
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
            $scope.sendInvitation = function () {
                ProviderInvitation.resend({ id: invitation.id },
                    function (success) {
                        ModalHandler.close($uibModalInstance);
                    },
                    function (failure) {
                        $scope.alerts = [];
                        Alert.error($scope.alerts, 'An error occurred during invitation resend...', true)
                    });
            }
        }])

    .controller('ErrorModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'message',
        function ($scope, $uibModalInstance, ModalHandler, message) {
            $scope.message = message;

            $scope.cancel = function () {
                ModalHandler.close($uibModalInstance);
            };
        }])

    .controller('SubscriptionChangeModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'locationsNumber', 'basePrice', 'subscriptionPrice', 'subscriptionInterval', 'cancelCallback',
        function ($scope, $uibModalInstance, ModalHandler, locationsNumber, basePrice, subscriptionPrice, subscriptionInterval, cancelCallback) {
            $scope.basePrice = basePrice;
            $scope.subscriptionPrice = subscriptionPrice;
            $scope.subscriptionInterval = subscriptionInterval;
            $scope.locationsNumber = locationsNumber;
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            };
            $scope.cancel = function () {
                cancelCallback();
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('ConfirmationModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'confirmMessage',
        function ($scope, $uibModalInstance, ModalHandler, confirmMessage) {
            $scope.confirmMessage = confirmMessage;
            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('UnsubscribeModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'confirmMessage',
        function ($scope, $uibModalInstance, ModalHandler, confirmMessage) {
            $scope.confirmMessage = confirmMessage;

            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            };
        }])

    .controller('SuccessGuestReferralModalController', ['$scope', '$uibModalInstance', 'ModalHandler',
        function ($scope, $uibModalInstance, ModalHandler) {
            $scope.message = "Almost done! We need you to confirm the entered email is yours. Please activate the referral by clicking the link in the email message we've sent to you.";

            $scope.ok = function () {
                ModalHandler.close($uibModalInstance);
            };
        }])

    .controller('RegistrationEmailResendModalController', ['$scope', '$uibModalInstance', 'ModalHandler',
        function ($scope, $uibModalInstance, ModalHandler) {
            $scope.ok = function () {
                ModalHandler.dismiss($uibModalInstance);
            }

        }])

    .controller('AddPluginVersionModalController', ['$scope', '$uibModalInstance', 'ModalHandler',
        function ($scope, $uibModalInstance, ModalHandler) {
            $scope.version = '';
            $scope.add = function () {
                ModalHandler.close($uibModalInstance, $scope.version);
            };
            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('VersionLogsModalController', ['$scope', '$uibModalInstance', 'ModalHandler', 'logs',
        function ($scope, $uibModalInstance, ModalHandler, logs) {
            $scope.logs = logs;

            $scope.cancel = function () {
                ModalHandler.dismiss($uibModalInstance);
            };
        }])

    .controller('InviteGuestModalController', ['$scope', '$modalInstance', 'ModalHandler', 'Referral', 'referral', 'Notification',
        function ($scope, $modalInstance, ModalHandler, Referral, referral, Notification) {

            $scope.invite = function () {
                Referral.sendGuestReferralUpdatedEmail({ id: referral.id },
                    function (success) {
                        Notification.success('Email to guest was sent successfully!');
                        referral.no_more_guest_conversion_offers = true; // no more than one offer email per referral. Server also sets it to true
                        ModalHandler.dismiss($modalInstance);
                    }, function (error) {
                        Notification.error('An error occurred.');
                        ModalHandler.dismiss($modalInstance);
                    });
            };

            $scope.skip = function () {
                ModalHandler.dismiss($modalInstance);
            };
        }]);
